export const JWT_CLAIM_DESCRIPTIONS: { [key: string]: string } = {
    alg: 'jwt_tool_claim_alg',
    typ: 'jwt_tool_claim_typ',
    iss: 'jwt_tool_claim_iss',
    sub: 'jwt_tool_claim_sub',
    aud: 'jwt_tool_claim_aud',
    exp: 'jwt_tool_claim_exp',
    nbf: 'jwt_tool_claim_nbf',
    iat: 'jwt_tool_claim_iat',
    jti: 'jwt_tool_claim_jti',
};

export const EXAMPLE_PAYLOAD = {
    "sub": "1234567890",
    "name": "John Doe",
    "iat": Math.floor(Date.now() / 1000),
    "exp": Math.floor(Date.now() / 1000) + (60 * 60) // Expires in 1 hour
};

export const EXAMPLE_HEADER = {
    "alg": "HS256",
    "typ": "JWT"
};